import React, { useEffect, useState } from 'react'

const TextScroll = ({ textItems }) => {
    const [scrollPosition, setScrollPosition] = useState(0);
  
    useEffect(() => {
      const handleScroll = () => {
        const scrollTop = window.scrollY;
        setScrollPosition(scrollTop);
      };
  
      window.addEventListener('scroll', handleScroll);
      return () => window.removeEventListener('scroll', handleScroll);
    }, []);
  
    return (
        <>
      <div className="text-scroll-container">
        <div
          className="text-scroll"
          style={{
            transform: `translateX(-${scrollPosition}px)`,
          }}
        >
          {textItems.map((text, index) => (
            <span key={index} className="text-scroll-item">
              {text}
            </span>
          ))}
        </div>
        <p className='secondary-text'>We enable international workforce solutions for you. Employ skills without restrictions</p>
      </div>
      
      </>
    );
  };

export default TextScroll